import { createFileRoute } from '@tanstack/react-router'
import ChapterOverview from '@/components/ChapterOverview'
import { getChapterBySlug } from '@/lib/chapters'

export const Route = createFileRoute('/basics/$basicsSlug/')({
  component: BasicsChapterIndex,
})

function BasicsChapterIndex() {
  const { basicsSlug } = Route.useParams()
  const entry = getChapterBySlug(basicsSlug)
  if (!entry) return null
  return (
    <ChapterOverview
      chapter={entry.chapter}
      basicsSlug={entry.basicsSlug}
      number={entry.number}
      summary={entry.summary}
      takeaways={entry.takeaways}
    />
  )
}
